/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvD8fU6%7Bborder-radius%3Avar(--ds-radius-large%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3hxITi6wH8%7Bborder-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3vBAKH9r67%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQm5zaO%7Bpadding-block-start%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xmtko5zaO%7Bpadding-block-end%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5E5zaO%7Bpadding-inline-start%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCP5zaO%7Bpadding-inline-end%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0wOv4Q7zJH%7Bcursor%3Apointer%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1kOSYtQiA2%7Btransition-property%3Abackground-color%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3Z9K0wlNGu%7Btransition-duration%3A.25s%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0qk6IKN8t6%7Btransition-timing-function%3Aease-in-out%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2fwxA5ecOK%7Btext-align%3Aleft%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1eOmH6o126%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdWVPG%7Bposition%3Aabsolute%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2I62gzPgdg%7Binset-block-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ZB6UyPgdg%7Binset-block-end%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iC0zdPgdg%7Binset-inline-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1OKFqYPgdg%7Binset-inline-end%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._42Yu6Bbhqd%7Bz-index%3A200%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCP1Y8M%7Bpadding-inline-end%3Avar(--ds-space-050%2C4px)%7D");
import React, { type ReactNode } from 'react';
import AkHeading from '@atlaskit/heading/heading';
import LegacyAnchor from '@atlaskit/primitives/anchor';
import LegacyBox from '@atlaskit/primitives/box';
import { Anchor } from '@atlaskit/primitives/compiled/anchor';
import { Box, Box as CompiledBox } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import LegacyInline from '@atlaskit/primitives/inline';
import LegacyStack from '@atlaskit/primitives/stack';
import Text from '@atlaskit/primitives/text';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';
import { AgentAvatar } from '@atlaskit/rovo-agent-components/ui/AgentAvatar';
import { useRecommendedAgents } from '@atlassian/conversation-assistant-agent/controllers/agents';
import { useAtlasURL } from '@atlassian/conversation-assistant-agent/controllers/atlas-url';
import { AgentCreatedBy } from '@atlassian/conversation-assistant-agent/utils/agents';
import { FormattedMessage } from 'react-intl';
import { useAnalytics } from '@townsquare/analytics';
import { fg } from '@townsquare/stat-sig/gate';
type AgentType = ReturnType<typeof useRecommendedAgents>['recommendedAgents'][number];
const cardStyles = xcss({
  borderWidth: 'border.width',
  borderStyle: 'solid',
  borderColor: 'color.border',
  borderRadius: 'radius.large',
  padding: 'space.200',
  cursor: 'pointer',
  transitionProperty: 'background-color',
  transitionDuration: '0.25s',
  transitionTimingFunction: 'ease-in-out',
  ':hover': {
    backgroundColor: 'color.background.neutral.subtle.hovered'
  },
  textAlign: 'left',
  position: 'relative'
});
const anchorOverlayStyles = xcss({
  position: 'absolute',
  inset: 'space.0',
  borderRadius: 'radius.large',
  zIndex: 'card'
});
const agentAuthorStyles = xcss({
  zIndex: 'card',
  display: 'flex',
  alignItems: 'center'
});
const styles = {
  card: "_0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _46hvQm5zaO _0xmtko5zaO _0LQT5E5zaO _03SyCP5zaO _0wOv4Q7zJH _1kOSYtQiA2 _3Z9K0wlNGu _0qk6IKN8t6 _2fwxA5ecOK _1mT5xdRAKS _1eOmH6o126",
  anchorOverlay: "_0bjKvD8fU6 _1mT5xdWVPG _2I62gzPgdg _1ZB6UyPgdg _3iC0zdPgdg _1OKFqYPgdg _42Yu6Bbhqd",
  agentAuthor: "_42Yu6Bbhqd _3iDTPbQ4SZ _0hPCNLDIqT",
  createdBy: "_1UtDYzZpcK _03SyCP1Y8M"
};
export function Agent({
  siteId,
  ...agent
}: {
  siteId: string;
} & AgentType): React.JSX.Element {
  const analytics = useAnalytics();
  const {
    atlasURL
  } = useAtlasURL(siteId);
  return fg('townsquare-compiled-xcss-to-cssmap-final') ? <Box testId={`agent-browse-card-${agent.id}`} xcss={styles.card}>
			<Anchor xcss={styles.anchorOverlay} href={atlasURL(`/people/agent/${agent.id}`)} target="_blank" onClick={() => void analytics.ui('browseAgentCard', 'clicked', {
      agentId: agent.id
    })} testId={`agent-browse-card-${agent.id}-clickable`} />
			<Stack grow="fill" space="space.200" spread="space-between">
				<Inline space="space.100" alignInline="start" alignBlock="center">
					<AgentAvatar agentNamedId={agent.external_config_reference ?? agent.named_id} agentId={agent.id} agentIdentityAccountId={agent.identity_account_id} size="medium" isForgeAgent={agent.creator_type === 'FORGE'} forgeAgentIconUrl={agent.icon} />
					<Stack>
						<AkHeading size="xsmall" as="h3">
							{agent.name}
						</AkHeading>
						<Box xcss={styles.agentAuthor}>
							<FormattedMessage id="townsquare.views.directory.browse-agent-card-created-by" description="Label to indicate the creator of the agent" defaultMessage="<text>by</text> {creatorName}" values={{
              text: (chunks: ReactNode[]) => <CompiledBox xcss={styles.createdBy}>{chunks}</CompiledBox>,
              creatorName: <AgentCreatedBy agent={agent} siteId={siteId} simplified />
            }} />
						</Box>
					</Stack>
				</Inline>
				<Text color="color.text.subtle" maxLines={2}>
					{agent.description}
				</Text>
			</Stack>
		</Box> : <LegacyBox testId={`agent-browse-card-${agent.id}`} xcss={cardStyles}>
			<LegacyAnchor xcss={anchorOverlayStyles} href={atlasURL(`/people/agent/${agent.id}`)} target="_blank" onClick={() => void analytics.ui('browseAgentCard', 'clicked', {
      agentId: agent.id
    })} testId={`agent-browse-card-${agent.id}-clickable`} />
			<LegacyStack grow="fill" space="space.200" spread="space-between">
				<LegacyInline space="space.100" alignInline="start" alignBlock="center">
					<AgentAvatar agentNamedId={agent.external_config_reference ?? agent.named_id} agentId={agent.id} agentIdentityAccountId={agent.identity_account_id} size="medium" isForgeAgent={agent.creator_type === 'FORGE'} forgeAgentIconUrl={agent.icon} />
					<LegacyStack>
						<AkHeading size="xsmall" as="h3">
							{agent.name}
						</AkHeading>
						<LegacyBox xcss={agentAuthorStyles}>
							<FormattedMessage id="townsquare.views.directory.browse-agent-card-created-by" description="Label to indicate the creator of the agent" defaultMessage="<text>by</text> {creatorName}" values={{
              text: (chunks: ReactNode[]) => <CompiledBox xcss={styles.createdBy}>{chunks}</CompiledBox>,
              creatorName: <AgentCreatedBy agent={agent} siteId={siteId} simplified />
            }} />
						</LegacyBox>
					</LegacyStack>
				</LegacyInline>
				<Text color="color.text.subtle" maxLines={2}>
					{agent.description}
				</Text>
			</LegacyStack>
		</LegacyBox>;
}